<script lang="ts">
    import {Component, Prop, Setup, toNative} from 'vue-facing-decorator'
    import __CompanyAutocomplete, {
        CompanyAutocomplete as _CompanyAutocomplete,
    } from '@/components/account/modals/newOrderRequest/CompanyAutocomplete.vue'

    @Component({mixins: [__CompanyAutocomplete]})
    export class SupplierSelectAutocomplete extends _CompanyAutocomplete {
        @Prop({type: Number, default: 10}) limit
        @Setup(() => useLocalized()) localized: Function

        async loadClients() {
            try {
                this.clients = []
                this.cancelTokenSources.forEach(cancelTokenSource => cancelTokenSource.cancel())
                this.cancelTokenSources = []
                this.isLoadingClients = true

                const cancelTokenSource = this.$axios.CancelToken.source()
                this.cancelTokenSources.push(cancelTokenSource)

                this.clients = (
                    await this.$api.suppliers.get(
                        {
                            name: this.searchInput,
                            limit: this.limit,
                        },
                        cancelTokenSource.token
                    )
                ).suppliers.sort((a, b) => a.name.localeCompare(b.name))
            } catch (e) {
                /* empty */
            } finally {
                this.isLoadingClients = false
            }
        }
    }

    export default {...toNative(SupplierSelectAutocomplete), ssrRender: __CompanyAutocomplete.ssrRender}
</script>
